import { render } from "./VoiceChatPropsCmp.vue?vue&type=template&id=2a3c0fbc"
import script from "./VoiceChatPropsCmp.vue?vue&type=script&lang=js"
export * from "./VoiceChatPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__